import { Button, ButtonGroup, Tooltip } from "@material-ui/core";
import { CloudDownload as DownloadIcon } from "@material-ui/icons";
import { get } from "lodash";
import moment from "moment";
import React, { useEffect, useState, useRef } from "react";
import { Trans, withTranslation } from "react-i18next";
import { connect, useSelector, useDispatch } from "react-redux";
import { compose, lifecycle, withHandlers, withState } from "recompose";
import { saveAs } from "file-saver";
import shpwrite from "@mapbox/shp-write";
import { ApiEndpoint } from "../../env.config";
import { mapLoaded, setSurveyedMapType, getVectorSourceInfo, setPointPopup, setTableData } from "../../services/actions/GisAction";
import { loading, resetLoading } from "../../services/actions/RoadAction";
import { ShowPermissionRequired } from "../../services/actions/SystemAction";
import {
  LAYER_IDS,
  MAIN_COLOR,
  MAPBOX_ACCESSTOKEN,
  MenuType,
  PermissionType,
  SOURCE_IDS
} from "../../shared/utils/constant";
import { authFileFetch } from "../../shared/utils/fetchUtils";
import {
  getDistanceFromLatLonInKm,
  HasPermissions,
  // zeroPadding,
} from "../../shared/utils/objectExtensions";
import DPYearSlider from "./DPYearSlider";
import SurveyedDetail from "./TopContent/SurveyedDetail";
import { BottomTableMaxCount, BottomTableBeforeSortMaxCount, BottomTableUpdateZoomBorder } from "../../env.config";

import {
  Layer,
  FullscreenControl as MapboxFullscreenControl,
  Map as MapboxMap,
  Marker as MapboxMarker,
  Popup as MapboxPopup,
  NavigationControl,
  Source
} from 'react-map-gl';
import { FilterSurface, FilterSurfaceForce } from "../../services/actions/SurfaceAction";
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import * as turf from "@turf/turf";
import markerIcon from "./icon/center_marker.png";

const Map = ({
  yearFilter,
  vectorTiles,
  showSurveyedDetail,
  dataDetailSelected,
  closeSurveyedDetail,
  coords,
  showAttributeList,
  rankFilters,
  shouldShowDetail,
  surveyedMapType,
  setMapType,
  downloadShapeFile,
  forceReloadMap,
  setForceReloadMap,
  surfaces,
  surfaceFilters, // アスファルト・コンクリ対応
  currentZoom,
  users,
  userFilter,
  mapEl,
  mapLoaded,
  pointPopup,
  setPointPopup,
  setFilterSurface,
  tableData,
  setTableData,
}) => {
  const userPosition = coords
    ? [get(coords, "latitude"), get(coords, "longitude")]
    : [30.55435, -91.03677];
  const currentUser =
    users?.find((x) => x.id == userFilter) ||
    JSON.parse(sessionStorage.getItem("userLogged"));
  const isOldUser = currentUser?.isOldUser ? true : false;
  const [currentCenterPoint, setCurrentCenterPoint] = React.useState(null);
  const pointClick = useRef({ lat: 0, lng: 0 }); // これいらないかも
  const dispatch = useDispatch();

  // state変数
  const { isActual, isPredicted, pointRowData, lineRowData } = useSelector((state) => ({
    isActual: state.gis.isActual,
    isPredicted: state.gis.isPredicted,
    pointRowData: state.gis.pointRowData,
    lineRowData: state.gis.lineRowData,
  }));

  // 各種監視変数
  const yearRef = useRef();
  yearRef.current = yearFilter;
  const surveyedMapTypeRef = useRef();
  surveyedMapTypeRef.current = surveyedMapType;
  const vectorTilesRef = useRef();
  vectorTilesRef.current = vectorTiles;

  // 表示中心座標
  const center =
    !isOldUser && currentCenterPoint
      ? currentCenterPoint
      : userPosition
        ? userPosition
        : [0, 0];

  const predictSurfaces = surfaces[0]?.hasPredict
    ? surfaces.map((x) => {
      const newItem = { ...x };
      if (newItem.rangeValue) {
        newItem.rangeValue = JSON.parse(x.rangeValue);
      }
      return newItem;
    })
    : null;

  // テーブルデータ取得対象操作フラグ
  let isGetDataOperation = true;

  // MapBox処理開始
  const [isClick, setIsClick] = useState(false);
  const [isLineDataSelected, setIsLineDataSelected] = useState(false);

  // フィルタリング処理
  // - distressAverage(Surface Condition)
  const rankFilterStyle = [];
  rankFilters.map((r, index) => {
    if (r.rangeValue != null) {
      const values = JSON.parse(r.rangeValue);
      const rankFilter = ["all"];
      rankFilter.push(['>=', ['round', ['get', 'distressAverage']], values[0]]);
      rankFilter.push(['<=', ['round', ['get', 'distressAverage']], values[1]]);
      rankFilterStyle.push(rankFilter);
    } else if (r.value != null) {
      rankFilterStyle.push(['==', ['get', 'distressAverage'], r.value])
    }
  });

  const convertHexToRGBA = (hex) => {
    // 空チェック
    if (hex == null || hex == '') {
      return hex;
    }

    // 9文字の長さかどうかを確認
    if (hex.length !== 9) {
      return hex;
    }

    // 先頭の '#' を取り除く
    if (hex.startsWith('#')) {
      hex = hex.slice(1);
    } else {
      return hex;
    }

    // 色部分と透明度部分に分割
    const rHex = hex.slice(0, 2);
    const gHex = hex.slice(2, 4);
    const bHex = hex.slice(4, 6);
    const aHex = hex.slice(6, 8);

    // 16進数から10進数に変換
    const r = parseInt(rHex, 16);
    const g = parseInt(gHex, 16);
    const b = parseInt(bHex, 16);
    const a = parseInt(aHex, 16);

    // 透明度を0から1の範囲に変換
    const alpha = (a / 255).toFixed(2);

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  // - distressAverageによる地物スタイル(色)の設定
  const yearPaintColorStyle = [];
  if (yearFilter) {
    surfaces.map((s, index) => {
      if (index == 0) yearPaintColorStyle.push('case');
      if (s.rangeValue) {
        // Range value (SPM-PCI/SPM-PCI-DP)
        const values = JSON.parse(s.rangeValue);
        const colorExpressions =
          [
            'all',
            ['>=', ['round', ['get', 'distressAverage']],
              values[0]], ['<=', ['round', ['get', 'distressAverage']],
              values[1]]
          ];
        yearPaintColorStyle.push(colorExpressions);
      } else {
        // Value (SPM-PASER)
        const colorExpressions = ['==', ['get', 'distressAverage'], s.value];
        yearPaintColorStyle.push(colorExpressions);
      }
      const color = convertHexToRGBA(s.color);
      yearPaintColorStyle.push(color);
      if (index == surfaces.length - 1) {
        yearPaintColorStyle.push(MAIN_COLOR);
      }
    });
  }

  // - アスファルト・コンクリフィルタ(Surface Type)
  const surfaceValues = [];
  surfaceFilters.map((s, index) => {
    surfaceValues.push(s.title);
  });

  // クリック処理(LINE)
  let hoveredStateLineId = null;
  const handleClickLine = (e) => {
    pointClick.current = e.lngLat;

    // NOTE 同じ緯度経度にタイムスライダの複数年の線があるため、タイムスライダの選択状態で絞り込む
    const targetFeature = e.features.filter((feature) => feature.properties.year === yearRef.current)[0];
    if (targetFeature == null) return;

    setPointPopup([0, 0]);

    // ベクタタイルはライン生成時に頂点を消している可能性があるため、クリック点を渡す
    const pos = e.lngLat.toArray().toReversed();

    const kp = targetFeature.properties._id;
    const surveyedDate = targetFeature.properties.surveyedDate;

    showSurveyedDetail(pos, surveyedDate, kp, { point: { lat: pointClick.current.lat, lng: pointClick.current.lng } });

    const markerPosition = calcMarkerLngLat(mapEl);
    getDataTableData('line', turf.point([markerPosition['lng'], markerPosition['lat']]), true);
    setIsClick(true);
  }

  // ホバー処理(LINE)
  const handleMouseMoveLine = (e) => {
    isGetDataOperation = false;
    mapEl.current.getCanvas().style.cursor = 'default';
    if (!vectorTilesRef.current) return;
    if (e.features.length === 0) return;
    if (hoveredStateLineId !== null) {
      mapEl.current.removeFeatureState({
        source: SOURCE_IDS.LINE,
        sourceLayer: getVectorSourceInfo(vectorTilesRef.current, "line").name,
        id: hoveredStateLineId
      });
      hoveredStateLineId = null;
    }
    // NOTE 同じ緯度経度にタイムスライダの複数年の線があるため、タイムスライダの選択状態で絞り込む
    const targetFeature = e.features.filter((feature) => feature.properties.year === yearRef.current)[0];
    if (!targetFeature) return;

    hoveredStateLineId = targetFeature.properties._id;
    mapEl.current.setFeatureState({
      source: SOURCE_IDS.LINE,
      sourceLayer: getVectorSourceInfo(vectorTilesRef.current, "line").name,
      id: hoveredStateLineId
    }, {
      hover: true
    });
  }

  // リーブ処理(LINE)
  const handleMouseLeaveLine = () => {
    isGetDataOperation = false;
    mapEl.current.getCanvas().style.cursor = '';
    if (hoveredStateLineId !== null && vectorTilesRef.current != null) {
      mapEl.current.removeFeatureState({
        source: SOURCE_IDS.LINE,
        sourceLayer: getVectorSourceInfo(vectorTilesRef.current, "line").name,
        id: hoveredStateLineId
      });
    }
    hoveredStateLineId = null;
  }

  // クリック処理(POINT)
  const handleClickPoint = (e) => {
    if (!mapEl.current || !vectorTilesRef.current) return;

    pointClick.current = e.lngLat.toArray();

    setPointPopup([0, 0]);
    const targetFeature = e.features.filter((feature) => feature.properties.year === yearRef.current)[0];
    const point = targetFeature.geometry.coordinates.toReversed();

    const kp = targetFeature.properties._id;
    const surveyedDate = targetFeature.properties.surveyedDate;
    showSurveyedDetail(point, surveyedDate, kp, null);
    
    const markerPosition = calcMarkerLngLat(mapEl);
    getDataTableData('point', turf.point([markerPosition['lng'], markerPosition['lat']]), true);
    setIsClick(true);
  }

  // ホバー処理(POINT)
  let hoveredStatePointId = null;
  const handleMouseMovePoint = (e) => {
    isGetDataOperation = false;
    mapEl.current.getCanvas().style.cursor = 'default';
    if (!vectorTilesRef.current) return;
    if (e.features.length === 0) return;

    if (hoveredStatePointId !== null) {
      mapEl.current.removeFeatureState({
        source: SOURCE_IDS.POINT,
        sourceLayer: getVectorSourceInfo(vectorTilesRef.current, "point").name,
        id: hoveredStatePointId
      });
      hoveredStatePointId = null;
    }
    // NOTE: 同じ緯度経度にタイムスライダの複数年の線があるため、タイムスライダの選択状態で絞り込む
    const targetFeature = e.features.filter((feature) => feature.properties.year === yearRef.current)[0];
    if (!targetFeature) return;
    hoveredStatePointId = targetFeature.properties._id;
    mapEl.current.setFeatureState({
      source: SOURCE_IDS.POINT,
      sourceLayer: getVectorSourceInfo(vectorTilesRef.current, "point").name,
      id: hoveredStatePointId
    }, {
      hover: true
    });
  }
  // リーブ処理(POINT)
  const handleMouseLeavePoint = () => {
    isGetDataOperation = false;
    mapEl.current.getCanvas().style.cursor = '';
    if (hoveredStatePointId !== null && vectorTilesRef.current != null) {
      mapEl.current.removeFeatureState({
        source: SOURCE_IDS.POINT,
        sourceLayer: getVectorSourceInfo(vectorTilesRef.current, "point").name,
        id: hoveredStatePointId
      });
    }
    hoveredStatePointId = null;
  }

  // マップ読込完了処理(POINT)
  const handleIdlePoint = () => {
    if (isGetDataOperation) {
      // マーカー座標の取得
      const markerPosition = calcMarkerLngLat(mapEl);
      // 地物取得
      getDataTableData('point', turf.point([markerPosition['lng'], markerPosition['lat']]), false);
    }
    isGetDataOperation = true;
  }

  // マップ読込完了処理(LINE)
  const handleIdleLine = () => {
    if (isGetDataOperation) {
      // マーカー座標の取得
      const markerPosition = calcMarkerLngLat(mapEl);
      // 地物取得
      getDataTableData('line', turf.point([markerPosition['lng'], markerPosition['lat']]), false);
    }
    isGetDataOperation = true;
  }

  // ロード時:初期位置への移動
  const handleLoad = () => {
    mapLoaded(true);
    mapEl.current.on('click', LAYER_IDS.LINE, handleClickLine);
    mapEl.current.on('mousemove', LAYER_IDS.LINE, handleMouseMoveLine);
    mapEl.current.on('mouseleave', LAYER_IDS.LINE, handleMouseLeaveLine);
    mapEl.current.on('click', LAYER_IDS.POINT, handleClickPoint);
    mapEl.current.on('mousemove', LAYER_IDS.POINT, handleMouseMovePoint);
    mapEl.current.on('mouseleave', LAYER_IDS.POINT, handleMouseLeavePoint);
    mapEl.current.on('idle', LAYER_IDS.POINT, handleIdlePoint);
    mapEl.current.on('idle', LAYER_IDS.LINE, handleIdleLine);

    // マーカーアイコンの作成
    const el = document.createElement('div');
    const width = 40;
    const height = 40;
    el.className = 'marker';
    el.style.backgroundImage = `url(${markerIcon})`;
    el.style.width = `${width}px`;
    el.style.height = `${height}px`;
    el.style.backgroundSize = '100%';
    // センターマーカーの作成
    const centerMarker = new mapboxgl.Marker(el);
    centerMarker.setLngLat(calcMarkerLngLat(mapEl))
    .addTo(mapEl.current.getMap());
    // 地図の動きにセンターマーカーを追従させる
    mapEl.current.on("move", () => {
      centerMarker.setLngLat(calcMarkerLngLat(mapEl));
    });
  }

  /**
   * マーカーの点を計算する
   * 地図画面全体からデータテーブルの高さを引いた値を/2した高さになるようにしている
   * @param {*} mapEl 
   * @returns 緯度経度情報
   */
  const calcMarkerLngLat = (mapEl) => {
    const viewportHeight = window.innerHeight;
    // 計算結果（例：50%の高さから100px下）
    const calcResult = (50 * viewportHeight / 100) - 100; // ピクセル値
    // 画面の中心点（x座標は中央、y座標はcalcResult）
    const point = [Math.round(window.innerWidth / 2), Math.round(((viewportHeight - 64) - calcResult) / 2) ]; // ピクセル座標
    // mapの`unproject()`を使って緯度・経度に変換
    const lngLat = mapEl.current.getMap().unproject(point);

    return lngLat;
  }

  /**
   * Sourceから取得できるboundsを基準にしたフォーカス処理
   * SourceはTileset情報を元にしており、これが地物に対し思ったようなboundsになっていないことがある。
   * これに関してはMapbox API由来になるため、現状こちらではコントロール不可
   * @returns
   */
  const setFocus = () => {
    if (mapEl.current == null) return false;
    const source = mapEl.current.getSource(surveyedMapType === "line" ? SOURCE_IDS.LINE : SOURCE_IDS.POINT);
    if (source && source.bounds != null) {
      const pCenter = [(source.bounds[0] + source.bounds[2]) / 2, (source.bounds[1] + source.bounds[3]) / 2]
      mapEl.current.setCenter(pCenter);
      return true;
    } else {
      return false;
    }
  }

  /**
   * setFocus処理のポーリング付き処理(繰り返し上限あり)
   * @param {*} duration ポーリング感覚(ms)
   * @param {*} loopMax 繰り返し上限(回)
   */
  const setFocusWithInterval = (duration = 1000, loopMax = 120) => {
    let count = 0;
    const timeID = setInterval(() => {
      // 現在のソースから中心位置を取得
      if (setFocus() === true) {
        clearInterval(timeID);
      }
      count++;
      if (count > loopMax) {
        // フォーカス処理:指定回数を超えたので中止
        clearInterval(timeID);
      }
    }, duration);
  }

  /**
   * DataTableに表示するfeatureデータの取得
   * @param {*} surveyedMapType マップ表示モード(フィルタ取得用)
   * @param {*} centerPoint 中心点の座標
   * @return {*} マップ中心点から近い順のfeatureデータ(上限1000件)
   */
  const getDataTableData = (surveyedMapType, centerPoint, isClick) => {
    if (mapEl.current.getZoom() < BottomTableUpdateZoomBorder) {
        setTableData([]);
        return;
    }
    if (!isClick) {
      dispatch(loading());
    }
    setTimeout(() => {
      try {
        const filter = mapEl.current.getFilter(surveyedMapType);
        if (!filter) return;
        
        let layerFilter = [];

        let hasRoadFilter = false;
        for (let f = 0; f < filter.length; f++) {
          if (surveyedMapType != 'line' 
              || !Array.isArray(filter[f])
              || filter[f].length < 2
              || filter[f][0] != 'any'
              || !Array.isArray(filter[f][1])
              || filter[f][1].length != 3
              || !Array.isArray(filter[f][1][1])
              || filter[f][1][1].length != 2
              || filter[f][1][1][0] != 'get'
              || filter[f][1][1][1] != 'roadName'
            ) {
            // ラインの場合、行選択フィルタは破棄しないとテーブル表示の件数が減ってしまう
            layerFilter.push(filter[f]);
          } 
          if (surveyedMapType == 'point' 
              && Array.isArray(filter[f])
              && filter[f].length >= 2
              && filter[f][0] == 'any'
              && Array.isArray(filter[f][1])
              && filter[f][1].length == 3
              && Array.isArray(filter[f][1][1])
              && filter[f][1][1].length == 2
              && filter[f][1][1][0] == 'get'
              && filter[f][1][1][1] == 'roadName') {
            hasRoadFilter = true;
          }
        }
        const maxCount = hasRoadFilter ? Number.MAX_VALUE : BottomTableMaxCount;
        const queryMaxCount = hasRoadFilter ? Number.MAX_VALUE : BottomTableBeforeSortMaxCount;

        const bounds = mapEl.current.getBounds();
        const sw = bounds.getSouthWest();
        const ne = bounds.getNorthEast();
        const polygonCoordinates = [[
          [sw.lng, sw.lat],
          [sw.lng, ne.lat],
          [ne.lng, ne.lat],
          [ne.lng, sw.lat],
          [sw.lng, sw.lat]
        ]];
        const boundsPolygon = turf.polygon(polygonCoordinates, {}); 
        const _turf = turf;
        const surveyedLayer = mapEl.current.getLayer(surveyedMapType);
        const features = mapEl.current.querySourceFeatures(surveyedMapType, {
          sourceLayer: surveyedLayer.sourceLayer,
          filter: layerFilter ? layerFilter : [],
        })
        .slice(0, queryMaxCount)
        .filter((item, index, self) => {
          let judgeResult = self.findIndex(e => e.id === item.id) > -1;
          if (judgeResult) {
            if (item.geometry.type == 'Point') {
              judgeResult = _turf.booleanContains(boundsPolygon, item);
            } else {
              if (item.geometry.type == 'MultiLineString') {
                const lineStrings = item.geometry.coordinates.map(coords => _turf.lineString(coords));
                let tempJudgeResult = false;
                for (let i = 0; i < lineStrings.length; i++) {
                  const line = lineStrings[i];
                  if (_turf.booleanContains(boundsPolygon, line) || _turf.booleanCrosses(boundsPolygon, line)) {
                    tempJudgeResult = true;
                    break;
                  }
                }
                judgeResult = tempJudgeResult;
              } else {
                judgeResult = _turf.booleanContains(boundsPolygon, item) || _turf.booleanCrosses(boundsPolygon, item);
              }
            }
          }
          return judgeResult;
        });
        let sorted = features
        .map((feature) => {
          let point = turf.pointOnFeature(feature);
          let distance = turf.distance(centerPoint, point, { units: "miles" });
          return { feature, distance };
        })
        .sort((a,b) => a.distance - b.distance);
        let sortedFeatures = sorted.map(item => item.feature);
        const workMap = {};
        let uniqueFeatures = [];
        if (sortedFeatures.length > 0 && sortedFeatures[0].geometry.type == 'Point') {
          uniqueFeatures = sortedFeatures;
        } else {
          // 道路名別に集約
          for (let f = 0; f < sortedFeatures.length; f++) {
            const id = "" + sortedFeatures[f].id;
            const roadName = sortedFeatures[f].properties.roadName;
            if (workMap[roadName] == null) {
              workMap[roadName] = {};
            }
            if (workMap[roadName][id] == null) {
              workMap[roadName][id] = sortedFeatures[f];
            }
          }

          const isNormalValue = (val) => {
            return val != null && val != "" && !isNaN(val);
          }
          const sumPropertyValues = (baseFeature, addFeature, propName) => {
            if (!isNormalValue(baseFeature.properties[propName])) {
              // 異常値の場合、0と読み替える
              baseFeature.properties[propName] = 0;
            }
            if (!isNormalValue(addFeature.properties[propName])) {
              // 異常値の場合、0と読み替える
              addFeature.properties[propName] = 0;
            }
            baseFeature.properties[propName] += addFeature.properties[propName];
          }

          // 道路ごとにID別集計
          for (const roadName in workMap) {
            const idMap = workMap[roadName];

            let uniqueFeature = null;
            for (const id in idMap) {
              const tmpFeature = idMap[id];
              if (uniqueFeature == null) {
                uniqueFeature = tmpFeature;
              } else {
                // 属性値加算
                sumPropertyValues(uniqueFeature, tmpFeature, "distressAverage");
                sumPropertyValues(uniqueFeature, tmpFeature, "totalPoint");
                sumPropertyValues(uniqueFeature, tmpFeature, "level1");
                sumPropertyValues(uniqueFeature, tmpFeature, "level2");
                sumPropertyValues(uniqueFeature, tmpFeature, "level3");
                sumPropertyValues(uniqueFeature, tmpFeature, "level4");
                sumPropertyValues(uniqueFeature, tmpFeature, "level5");
                sumPropertyValues(uniqueFeature, tmpFeature, "level6");
                sumPropertyValues(uniqueFeature, tmpFeature, "level7");
              }
            }
            if (uniqueFeature != null) {
              // distressAverageは平均値
              uniqueFeature.properties["distressAverage"] /= Object.keys(idMap).length;
              uniqueFeatures.push(uniqueFeature);
            }
          }
        }

        if (!isLineDataSelected) {
          if (uniqueFeatures.length > maxCount) {
            uniqueFeatures = uniqueFeatures.slice(0, maxCount);
          }
        } else {
          // NOP.
        }
        setTableData(uniqueFeatures);
      } finally {
        if (!isClick) {
          dispatch(resetLoading());
        }
      }
    }, 50);
  }

  /**
   * DataTableでLINEデータが選択されたかどうかの制御
   * @param {*} flag LINEテーブルデータ選択フラグ
   */
  const handleIsLineDataSelected = (flag) => {
    setIsLineDataSelected(flag);
  }

  const [sourceLayerPoint, setSourceLayerPoint] = useState("");
  const [sourceUrlPoint, setSourceUrlPoint] = useState("");
  const [sourceLayerLine, setSourceLayerLine] = useState("");
  const [sourceUrlLine, setSourceUrlLine] = useState("");
  useEffect(() => {
    if (mapEl.current == null) return;
    if (userFilter == null) return;
    if (vectorTiles == null) return;

    // line選択時、Surface Typeフィルタのリセット
    if (surveyedMapType === "line") {
      setFilterSurface(null);
    }

    const pointInfo = getVectorSourceInfo(vectorTiles, "point");
    const lineInfo = getVectorSourceInfo(vectorTiles, "line");
    if (surveyedMapType === "point") {
      if (mapEl.current.getLayer(LAYER_IDS.POINT)?.sourceLayer !== pointInfo.name) {
        if (mapEl.current.getMap().getLayer(LAYER_IDS.POINT)) {
          mapEl.current.getMap().removeLayer(LAYER_IDS.POINT);
          mapEl.current.getMap().removeSource(SOURCE_IDS.POINT);
        }
        setSourceLayerPoint(pointInfo.name);
        setSourceUrlPoint("mapbox://" + pointInfo.id);
        setSourceLayerLine(lineInfo.name);
        setSourceUrlLine("mapbox://" + lineInfo.id);
        setFocusWithInterval();
      }
    } else if (surveyedMapType === "line") {
      if (mapEl.current.getLayer(LAYER_IDS.LINE)?.sourceLayer !== lineInfo.name) {
        if (mapEl.current.getMap().getLayer(LAYER_IDS.LINE)) {
          mapEl.current.getMap().removeLayer(LAYER_IDS.LINE);
          mapEl.current.getMap().removeSource(SOURCE_IDS.LINE);
        }
        setSourceLayerPoint(pointInfo.name);
        setSourceUrlPoint("mapbox://" + pointInfo.id);
        setSourceLayerLine(lineInfo.name);
        setSourceUrlLine("mapbox://" + lineInfo.id);
        setFocusWithInterval();
      }
    }
  }, [userFilter, vectorTiles, surveyedMapType]);

  // filter条件を網羅した状態を作成する
  const filterAll = ['all'];
  // yearFilter(必須)
  filterAll.push(['==', ['get', 'year'], yearFilter]);

  // distressFilter(任意)
  if (rankFilterStyle.length > 0) {
    const tmpFilter = ["any"];
    for (const rankFilter of rankFilterStyle) {
      tmpFilter.push(rankFilter);
    }
    filterAll.push(tmpFilter);
  }

  // surfaceFilter(任意)
  if (surfaceValues.length > 0) {
    filterAll.push(["in", ["get", "surface"], ["literal", surfaceValues]]);
  }

  // dataType(Actual/Predicted)
  if (isPredicted && !isActual) {
    filterAll.push(["==", ["get", "isP"], true]);
  } else if (!isPredicted && isActual) {
    filterAll.push(["==", ["get", "isP"], false]);
  } else if (!isPredicted && !isActual) {
    filterAll.push(["==", ["get", "isP"], 99]);
  }

  // LINEテーブルのレコード選択時、roadNameが同じフィーチャのみ表示するようフィルタ条件追加
  if (lineRowData !== null && lineRowData.length > 0) {
      const tmpFilter = ["any"];
      for (let r = 0; r < lineRowData.length; r++) {
        if (lineRowData[r].distressAverage != null) {
          tmpFilter.push(['==', ['get', 'roadName'], lineRowData[r].roadName]);
        }
      }
      filterAll.push(tmpFilter);
  } else if (lineRowData === null) {
    for (let i = 0; i < filterAll.length; i++) {
      if (filterAll.includes(['get', 'roadName'])) {
        filterAll.splice(i, 1);
        break;
      }
    }  
  }

  // POINTテーブルのレコード選択時、ポップアップ表示
  useEffect(() => {
    if (pointRowData !== null && pointRowData.distressAverage != null) {
      pointClick.current = [pointRowData.point[1], pointRowData.point[0]];
      setPointPopup([0, 0]);
      showSurveyedDetail([pointRowData.point[0], pointRowData.point[1]], pointRowData.surveyedDate, pointRowData._id, null);
      setIsClick(true);
    }
  }, [pointRowData]);

  // LINEテーブルのレコード選択時、選択フラグON
  useEffect(() => {
    if (lineRowData !== null 
        && lineRowData.length > 0
        && lineRowData[0].distressAverage != null) {
      handleIsLineDataSelected(true);
    }
  }, [lineRowData]);


  return (
    <>
      {/* 地図全体 */}
      {(
        <MapboxMap
          ref={mapEl}
          mapboxAccessToken={MAPBOX_ACCESSTOKEN}
          maxZoom={17}
          minZoom={1}
          dragRotate={false}
          touchZoomRotate={false}
          logoPosition="bottom-right"
          // NOTE 初期位置は別途指定
          initialViewState={{
            longitude: center[1],
            latitude: center[0],
            zoom: currentZoom
          }}
          style={{
            height: `calc(100vh - ${showAttributeList
              ? window.innerHeight < 700
                ? "264px"
                : "364px"
              : "64px"
              })`,
          }}
          mapStyle="mapbox://styles/mapbox/light-v11"
          onLoad={handleLoad}
          onDragEnd={() => {
            // ポップアップ表示時にD&Dで自動で閉じるかどうかの判定
            const centerPoint = mapEl?.current?.getCenter();
            if (JSON.stringify(pointPopup) != JSON.stringify([0, 0]) && shouldShowDetail) {
              const distanceFromCenter = getDistanceFromLatLonInKm(
                centerPoint.lat,
                centerPoint.lng,
                pointPopup[0],
                pointPopup[1]
              );
              if (distanceFromCenter > 5) {
                setIsClick(false)
                closeSurveyedDetail();
                // alert("The detail marker is closed because it's out of the map.")
              }
            }
            if (centerPoint) {
              setCurrentCenterPoint([centerPoint.lat, centerPoint.lng]);
            }
            setForceReloadMap(true);
          }}>
          {/* 拡大縮小ボタン */}
          <NavigationControl showCompass={false} />
          {/* 最大化 */}
          <MapboxFullscreenControl />
          {/* yearスライダー */}
          <DPYearSlider closeSurveyedDetail={closeSurveyedDetail} />
          {/* LINE|POINT */}
          <ButtonGroup size="small" className="map-panel-type" style={{ position: 'absolute', top: '120px', right: '10px' }}>
            <Button
              className={`${surveyedMapType === "point" ? "type-selected" : ""}`}
              onClick={() => setMapType("point")}>
              Point
            </Button>
            <Button
              className={`${surveyedMapType === "line" ? "type-selected" : ""}`}
              onClick={() => setMapType("line")}>
              Line
            </Button>
          </ButtonGroup>
          {/* Shapeダウンロード */}
          {vectorTiles && (
            <ButtonGroup size="small" style={{ position: 'absolute', top: '160px', right: '10px' }}>
              <Button
                variant="outlined"
                size="small"
                className="btn-download-shape-file"
                onClick={downloadShapeFile}>
                <Tooltip title={<Trans>download_shapefile</Trans>} aria-label="add">
                  <DownloadIcon />
                </Tooltip>
              </Button>
            </ButtonGroup>
          )}
          {/* ベクタータイル利用時のレイヤー */}
          {/* Line */}
          {surveyedMapType === "line" && vectorTiles && (
            <>
              <Source id={SOURCE_IDS.LINE} type="vector" url={sourceUrlLine} promoteId="_id">
                <Layer
                  id={LAYER_IDS.LINE}
                  source-layer={sourceLayerLine}
                  filter={filterAll}
                  type='line'
                  paint={{
                    'line-width': [
                      'case',
                      ['boolean', ['feature-state', 'hover'], false], // hoverの値取得、デフォルト値false、の意
                      6,  // hover時
                      3,  // 通常時
                    ],
                    'line-color': yearPaintColorStyle,
                  }}
                />
                {/* ラベル */}
                <Layer
                  id={LAYER_IDS.LINE_LABEL}
                  source-layer={sourceLayerLine}
                  filter={filterAll}
                  type="symbol"
                  paint={{
                    "text-color": "#000000",
                    "text-halo-color": "#ffffff",
                    "text-halo-width": 1.5
                  }}
                  layout={{
                    "text-size": 12,
                    "text-field": ["get", "distressAverage"],
                    "text-rotation-alignment": "viewport", // これを入れないとラインの角度にラベルが依存する形になる
                    "symbol-placement": "line-center",
                    "text-translate": [0, 1]
                  }}
                />
              </Source>
            </>
          )}
          {/* Point */}
          {surveyedMapType === "point" && vectorTiles && (
            <>
              <Source id={SOURCE_IDS.POINT} type="vector" url={sourceUrlPoint} promoteId="_id">
                <Layer
                  id={LAYER_IDS.POINT}
                  source-layer={sourceLayerPoint}
                  filter={filterAll}
                  type="circle"
                  paint={{
                    'circle-radius': [
                      'case',
                      ['boolean', ['feature-state', 'hover'], false], // hoverの値取得、デフォルト値false、の意
                      8,  // hover時
                      5   // 通常時
                    ],
                    'circle-color': yearPaintColorStyle,
                  }}
                />
              </Source>
            </>
          )}
          {isClick && shouldShowDetail && dataDetailSelected && (
            <MapboxMarker
              longitude={pointPopup ? pointPopup[1] : -96.64943}
              latitude={pointPopup ? pointPopup[0] : 32.882874}
              className="popup-road-detail">
              {/* ポップアップ */}
              <MapboxPopup
                longitude={pointPopup ? pointPopup[1] : -96.64943}
                latitude={pointPopup ? pointPopup[0] : 32.882874}
                onClose={() => {
                  setIsClick(false);
                  closeSurveyedDetail();
                }}
                className={`popup-road-detail ${surveyedMapType === "line" ? "" : "popup-content-point"}`}
                maxWidth="600px">
                {/* ポップアップ詳細情報 */}
                <SurveyedDetail
                  {...dataDetailSelected}
                  // surveyedDataの中身を確認し、ベクタータイルのプロパティから生成する
                  showSurveyedDetail={showSurveyedDetail}
                  surveyedData={[]}
                  closeSurveyedDetail={closeSurveyedDetail}
                  setIsClick={setIsClick} />
              </MapboxPopup>
            </MapboxMarker>
          )}
        </MapboxMap>
      )}
    </>
  );
};
export default compose(
  withTranslation("translations"),
  withState("forceReloadMap", "setForceReloadMap", false),
  withState("currentZoom", "setCurrentZoom", 15),
  connect(
    (state) => ({
      vectorTiles: state.road.vectorTiles,
      showAttributeList: state.road.showAttributeList,
      rankFilters: state.road.rankFilters,
      surveyedMapType: state.gis.surveyedMapType,
      loading: state.gis.loading,
      surfaces: state.surface.surfaces,
      userFilter: state.road.userFilter,
      loggedUser: state.auth.user,
      users: state.user.users,
      yearFilter: state.road.yearFilter,
      showTopContent: state.gis.showTopContent,
      surfaceFilters: state.surface.surfaceFilters, // アスファルト・コンクリ対応
      mapLoaded: state.gis.mapLoaded,
      pointPopup: state.gis.pointPopup, // ポップアップ基点座標
      tableData: state.gis.tableData,
    }),
    (dispatch) => ({
      setMapType: (value) => dispatch(setSurveyedMapType(value)),
      showPermissionRequired: () => dispatch(ShowPermissionRequired()),
      showLoading: () => dispatch(loading()),
      hideLoading: () => dispatch(resetLoading()),
      mapLoaded: (value) => dispatch(mapLoaded(value)),
      setPointPopup: (value) => dispatch(setPointPopup(value)),
      setFilterSurface: (surface) => dispatch(FilterSurface(surface)),
      setTableData: (data) => dispatch(setTableData(data)),
    })
  ),
  withHandlers({
    downloadShapeFile:
      ({
        surveyedMapType,
        rankFilters,
        showPermissionRequired,
        surfaces,
        userFilter,
        loggedUser,
        showLoading,
        hideLoading,
        yearFilter,
      }) =>
        async () => {
          if (!HasPermissions(MenuType.DataTable, PermissionType.Download)) {
            return showPermissionRequired();
          }
          showLoading();
          try {
            const yearParam = yearFilter ? `year=${yearFilter}` : "";
            const userId = userFilter;
            const features = await (await authFileFetch(
              `${ApiEndpoint}/Road/surveyed/${userId}/type/${surveyedMapType}?${yearParam}`,
              { method: "GET" }
            )).json();
            const fileName = `pms_shapefile_${surveyedMapType === "line" ? "line_" : "point_"}${moment().format("DDMMYYYYhhmmss")}`;
            const options = {
              file: fileName,
              folder: fileName,
              outputType: "blob",
              types: {
                point: "points",
                polygon: "polygons",
                polyline: "polylines",
              },
            };
            shpwrite.zip({
              type: "FeatureCollection",
              features: features,
            }, options)
            .then((blob) => {
              saveAs(blob, options.file + '.zip');
              hideLoading();
            });
          } catch (error) {
            console.error(error);
            hideLoading();
          }
        },
  }),
  lifecycle({
    componentWillUpdate(nextProps) {
      try {
        if (JSON.stringify(this.props.surveyedAllocated) !== JSON.stringify(nextProps.surveyedAllocated)) {
          this.props.setForceReloadMap(true);
        }
      } catch (_err) {
        //ignored
      }
    },
    componentDidUpdate(prevProps) {
      if (this.props.forceReloadMap) {
        this.props.setForceReloadMap(false);
      }
      try {
        if ((!this.props.showTopContent && prevProps.showTopContent) ||
          JSON.stringify(prevProps.rankFilters) !== JSON.stringify(this.props.rankFilters)) {
          setTimeout(() => {
            this.props.setForceReloadMap(true);
          }, 500);
        }
      } catch (_err) {
        //ignored
      }
    },
    componentWillUnmount() {
      this.props.mapLoaded(false);
    }
  })
)(Map);
